"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NativeSelect.default;
  }
});

var _NativeSelect = _interopRequireDefault(require("./NativeSelect"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/NativeSelect/index.js
 ** module id = 900
 ** module chunks = 0
 **/